import React from "react"
import { canRequireUser } from '../../login/loginHelpers';
import { Modal } from "../../common/components/Modal";
import { AccountData } from "../../generated";
import NewsRepository from "../NewsRepository";
import { Link } from "react-router-dom";
import { links } from "../../routes";

export const NewsModal = canRequireUser((props: { user: AccountData | null }) => {
    const newsModal = React.useRef<Modal>(null);
    const news = NewsRepository.getForUser(props.user)
    React.useEffect(() => {
        if (news.length > 0)
            newsModal.current?.open();
    }, [])


    const { user } = props;
    if (user == null || user.lastAccess == null || news.length === 0)
        return null;


    return (<Modal ref={newsModal}>
        <div className="d-flex flex-column align-items-center">
            <h1 className="text-primary fw-bolder"><i className="fas fa-glass-cheers me-2" />  NOVITA'!</h1>
            <h3>Sono disponibili {news.length} nuovi aggiornamenti di Caldaie Manager.</h3>
            <Link
                to={links.news}
                onClick={() => newsModal?.current?.close()}
                className="btn btn-primary btn-lg my-5">
                Clicca qui per visualizzare
            </Link>
        </div>
    </Modal>)

});
